import formSelectMixin from './formSelect.js';
import formInputRadioPropsMixin from './formInputRadioProps.js';

export default {
  mixins: [formSelectMixin, formInputRadioPropsMixin],
};
